import { useQuery } from '@tanstack/react-query';
import { EstimatedManagementFeeResponse } from 'views/shared/types';
import { logError } from 'components/LogError';
import { fetchEstimatedFeeAmounts } from '../services/fetchEstimatedFeeAmounts';

interface UseEstimatedFeeAmountsReturnHookResponse {
  estimatedFeeAmounts: EstimatedManagementFeeResponse;
  loading: boolean;
  error: unknown;
}

interface UseEstimatedFeeAmountsProps {
  enabled?: boolean;
}

export const useEstimatedFeeAmounts = ({
  enabled = true,
}: UseEstimatedFeeAmountsProps = {}): UseEstimatedFeeAmountsReturnHookResponse => {
  const {
    data: estimatedFeeAmounts,
    isLoading: loading,
    error,
  } = useQuery({
    queryFn: fetchEstimatedFeeAmounts,
    queryKey: ['fetchEstimatedFeeAmounts'],
    enabled,
    staleTime: 10 * 60 * 1000, // 10 min - fee amounts rarely change
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  if (error) {
    logError(JSON.stringify(error));
  }
  return {
    estimatedFeeAmounts: estimatedFeeAmounts ?? {
      monthlyFeeAmount: 0,
      annualFeeAmount: 0,
      discountedAnnualFeeAmount: 0,
      discountPct: 0,
    },
    loading,
    error,
  };
};
